module.exports = __webpack_public_path__ + "img/product_banner_05.0c9d393d.jpg";